import { EntityManager } from "@/components/EntityManager";
import { EIA_REGION_OPTIONS } from "@/constants/options";

const money = (v) => (v == null || v === "" ? <span className="text-neutral-300">—</span> : `$${Number(v).toFixed(3)}`);

export default function DieselPrices() {
  const columns = [
    { key: "region_key", label: "Region Key" },
    { key: "region_name", label: "EIA Region" },
    { key: "diesel_price", label: "Diesel $/gal", align: "right", render: (r) => money(r.diesel_price) },
    { key: "week_ending", label: "Week Ending" },
  ];
  const fields = [
    { label: "Region Key", field: "region_key", type: "select", options: EIA_REGION_OPTIONS },
    { label: "EIA Region Name", field: "region_name" },
    { label: "Diesel Price ($/gal)", field: "diesel_price", type: "number" },
    { label: "Week Ending", field: "week_ending", type: "date" },
  ];
  return (
    <EntityManager collection="eia_prices" title="Diesel Prices"
      subtitle="Editable EIA regional diesel prices used for fuel cost estimation"
      columns={columns} fields={fields} />
  );
}
